<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 9C16.5 13.14 13.14 16.5 9 16.5C4.86 16.5 1.5 13.14 1.5 9C1.5 4.86 4.86 1.5 9 1.5C13.14 1.5 16.5 4.86 16.5 9Z" stroke="url(#paint0_linear_1765_177)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.7827 11.3851L9.45766 9.99757C9.05266 9.75757 8.72266 9.18007 8.72266 8.70757V5.63257" stroke="url(#paint1_linear_1765_177)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
      <linearGradient id="paint0_linear_1765_177" x1="19.6358" y1="-16.3184" x2="31.6704" y2="11.838" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6782F6"/>
        <stop offset="1" stop-color="#41DEBD"/>
      </linearGradient>
      <linearGradient id="paint1_linear_1765_177" x1="12.4224" y1="-1.20078" x2="18.6579" y2="6.55958" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6782F6"/>
        <stop offset="1" stop-color="#41DEBD"/>
      </linearGradient>
    </defs>
  </svg>
</template>